import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import PreShopEditConfirm from './PreShopEditConfirm';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import ValidationText from '../../components/atoms/ValidationText';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import { getPreShops, editPreShop } from '../../actions/PreShops';
import { sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import { getOptionCities } from '../../actions/Cities';
import { getZipCode } from '../../actions/Shop';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  editTable: {
    width: 'auto'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      cities: state.cities.listCities,
      prefectures: state.commons.prefectures
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getPreShops, editPreShop, getAccounts, getOptionCities, getZipCode },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openEditProgress', 'updateOpenEditProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isEditSuccess', 'updateIsEditSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('preShopId', 'setPreShopId', ''),
  withState('preShopName', 'setPreShopName', ''),
  withState('countryCode', 'setCountryCode', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', ''),
  withState('city', 'setCity', ''),
  withState('cityId', 'setCityId', ''),
  // withState('cityName', 'setCityName', ''),
  // withState('cityNameError', 'setCityNameError', ''),
  withState('address', 'setAddress', ''),
  withState('building', 'setBuilding', ''),
  withState('phone', 'setPhone', ''),
  withState('email', 'setEmail', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('access', 'setAccess', ''),
  withState('webPage', 'setWebPage', ''),
  withState('status', 'setStatus', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('preShopNameError', 'setPreShopNameError', ''),
  withState('zipCodeError', 'setZipCodeError', ''),
  withState('cityError', 'setCityError', ''),
  withState('addressError', 'setAddressError', ''),
  withState('phoneError', 'setPhoneError', ''),
  withState('emailError', 'setEmailError', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.setPreShopId(this.props.editInput.preShopId);
      this.props.setPreShopName(this.props.editInput.preShopName);
      this.props.setCountryCode(this.props.editInput.countryCode);
      this.props.setZipCode(this.props.editInput.zipCode);
      this.props.setPrefectureCode(this.props.editInput.prefectureCode);
      this.props.setCity(this.props.editInput.city);
      this.props.setCityId(this.props.editInput.cityId);
      this.props.setAddress(this.props.editInput.address);
      this.props.setBuilding(this.props.editInput.building);
      this.props.setPhone(this.props.editInput.phone);
      this.props.setEmail(this.props.editInput.email);
      this.props.setBusinessHours(this.props.editInput.businessHours);
      this.props.setHoliday(this.props.editInput.holiday);
      this.props.setAccess(this.props.editInput.access);
      this.props.setWebPage(this.props.editInput.webPage);
      this.props.setStatus(this.props.editInput.status);
      this.props.setUpdatedAt(this.props.editInput.updatedAt);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    searchKey,
    editInput,
    prefectures,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    openEditProgress,
    updateOpenEditProgress,
    loading,
    updateLoading,
    isEditSuccess,
    updateIsEditSuccess,
    resultMessage,
    setResultMessage,
    preShopId,
    preShopName,
    setPreShopName,
    countryCode,
    zipCode,
    setZipCode,
    prefectureCode,
    setPrefectureCode,
    cities,
    city,
    setCity,
    cityId,
    setCityId,
    // cityName,
    // setCityName,
    address,
    setAddress,
    building,
    setBuilding,
    phone,
    setPhone,
    email,
    setEmail,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    access,
    setAccess,
    webPage,
    setWebPage,
    status,
    updatedAt,
    preShopNameError,
    setPreShopNameError,
    zipCodeError,
    setZipCodeError,
    // cityError,
    // setCityError,
    cityIdError,
    setCityIdError,
    addressError,
    setAddressError,
    phoneError,
    setPhoneError,
    emailError,
    setEmailError
  }) => {
    const editConfirm = {
      preShopName,
      zipCode,
      prefectureCode,
      // city,
      city,
      address,
      building,
      phone,
      email,
      businessHours,
      holiday,
      access,
      webPage
    };

    const editParam = {
      preShopName,
      countryCode,
      zipCode,
      prefectureCode,
      city,
      // cityName,
      cityId,
      address,
      building,
      phone,
      email,
      businessHours,
      holiday,
      access,
      webPage,
      status,
      updatedAt
    };

    const errors = {
      preShopNameError,
      zipCodeError,
      // cityError,
      cityIdError,
      addressError,
      phoneError,
      emailError
    };

    const checkCityName = () => {
      const chosenCityNameList = [];
      cities
        .filter(item => item.cityName && item.cityName === editInput.city)
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      if (chosenCityNameList.length > 0) {
        return Number(chosenCityNameList[0].value);
      }
      return Number(0);
    };

    useEffect(() => {
      setCityId(checkCityName());
    }, [city]);

    const getZipCodeData = async zipcode => {
      await actions.getZipCode(zipcode).then(data => {
        setPrefectureCode(data.payload.prefectureCode);
        setCity(data.payload.city);
        setAddress(data.payload.address);
      });
    };

    const validPreShopName = () => {
      const value = preShopName;
      if (value === '') {
        setPreShopNameError('必須項目です。');
        return 1;
      }
      setPreShopNameError('');
      setPreShopName(value);
      return 0;
    };
    const validZipCode = () => {
      const value = zipCode;
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      getZipCodeData(value);
      return 0;
    };
    const validZipCodeSubmit = () => {
      const value = zipCode;
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      return 0;
    };
    // const validCity = () => {
    //   const value = city;
    //   if (value === '') {
    //     setCityError('必須項目です。');
    //     return 1;
    //   }
    //   setCityError('');
    //   setCity(value);
    //   return 0;
    // };
    const validCityId = () => {
      const value = cityId;
      if (value === 0) {
        setCityIdError('必須項目です。');
        return 1;
      }
      setCityIdError('');
      setCityId(value);
      return 0;
    };
    const setCityNameData = id => {
      cities.forEach(item => {
        if (id === item.cityId) {
          setCity(item.cityName);
        }
      });
    };
    const validAddress = () => {
      const value = address.trim();
      if (value === '') {
        setAddressError('必須項目です。');
        return 1;
      }
      setAddressError('');
      setAddress(value);
      return 0;
    };
    const validPhone = () => {
      const value = phone;
      if (value === '') {
        setPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setPhoneError('');
      setPhone(value);
      return 0;
    };
    const validEmail = () => {
      const value = email;
      if (value === '') {
        setEmailError('必須項目です。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };
    const valid = () => {
      const errorCount =
        validPreShopName() +
        validZipCodeSubmit() +
        validCityId() +
        validAddress() +
        validPhone() +
        validEmail();
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const cancelAction = () => updateOpenEditModal(false);
    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setCityNameData(cityId);
        updateOpenEditConfirm(true);
      }
    };
    const backAction = () => updateOpenEditConfirm(false);
    const editAction = async () => {
      updateLoading(true);
      updateOpenEditProgress(true);
      const editedPreShop = await actions
        .editPreShop(preShopId, editParam)
        .then(data => checkSession(data));
      if (editedPreShop.type === 'EDIT_PRE_SHOP_SUCCESS') {
        updateIsEditSuccess(true);
        actions.getPreShops(searchKey).then(data => {
          actions.getAccounts({ cognitoUserId: '' });
          checkSession(data);
        });
        setResultMessage('編集が完了しました。');
        updateLoading(false);
      } else {
        updateIsEditSuccess(false);
        setResultMessage('編集に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isEditSuccess) {
        updateOpenEditModal(false);
        updateOpenEditConfirm(false);
        updateOpenEditProgress(false);
      } else {
        updateOpenEditProgress(false);
      }
    };

    const getCitiesOptions = () => {
      const citiesOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (!prefectureCode || prefectureCode === 0) {
        cities.forEach(item => {
          citiesOptions.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      } else {
        cities
          .filter(
            item =>
              item.prefCode && Number(item.prefCode) === Number(prefectureCode)
          )
          .forEach(item => {
            citiesOptions.push({
              label: item.cityName,
              value: String(item.cityId)
            });
          });
      }
      return { ...citiesOptions, tmpObj };
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">仮店舗編集</Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.editTable}>
            <TableRow>
              <TableCell>
                <RequiredButton />
              </TableCell>
              <TableCell>
                <TextField
                  required
                  label="仮店舗名"
                  defaultValue={editInput.preShopName}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setPreShopName(e.target.value);
                  }}
                  onBlur={validPreShopName}
                />
                <ValidationText message={errors.preShopNameError} />
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="郵便番号"
                  defaultValue={editInput.zipCode}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setZipCode(e.target.value);
                  }}
                  onBlur={validZipCode}
                />
                <ValidationText message={errors.zipCodeError} />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone} />
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  select
                  label="都道府県"
                  className={classes.textField}
                  margin="normal"
                  value={prefectureCode}
                  onChange={e => {
                    setPrefectureCode(e.target.value);
                    setCityId(Number(0));
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                >
                  {prefectures.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </TableCell>
              <TableCell className={classes.tableCellBorderNone} />
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                {prefectureCode > 0 && (
                  <ReactSelectMaterialUi
                    required
                    label="市区町村*"
                    fullWidth
                    className={classes.textField}
                    defaultValue={String(checkCityName())}
                    options={getCitiesOptions()}
                    margin="normal"
                    onChange={z => {
                      setCityId(Number(z));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validCityId}
                  />
                )}
                {(!prefectureCode || prefectureCode <= 0) && (
                  <ReactSelectMaterialUi
                    disabled
                    required
                    fullWidth
                    label="市区町村*"
                    className={classes.textField}
                    defaultValue={String(checkCityName())}
                    options={getCitiesOptions()}
                    margin="normal"
                    onChange={z => {
                      setCityId(Number(z));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validCityId}
                  />
                )}
                {editInput.city && !cityId && checkCityName() <= 0 && (
                  <Typography variant="h7">
                    市区町村はまだ正規化されません。再度設定してください。
                  </Typography>
                )}
                <ValidationText message={errors.cityIdError} />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone} />
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone} />
              <TableCell className={classes.tableCellBorderNone}>
                <TextField
                  required
                  label="丁目・番地"
                  defaultValue={editInput.address}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setAddress(e.target.value);
                  }}
                  onBlur={validAddress}
                />
                <ValidationText message={errors.addressError} />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone} />
            </TableRow>
            <TableRow>
              <TableCell />
              <TableCell>
                <TextField
                  label="建物名"
                  defaultValue={editInput.building}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setBuilding(e.target.value);
                  }}
                />
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>
                <RequiredButton />
              </TableCell>
              <TableCell>
                <TextField
                  required
                  label="電話番号"
                  defaultValue={editInput.phone}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setPhone(e.target.value);
                  }}
                  onBlur={validPhone}
                />
                <ValidationText message={errors.phoneError} />
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>
                <RequiredButton />
              </TableCell>
              <TableCell>
                <TextField
                  required
                  label="メールアドレス"
                  defaultValue={editInput.email}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setEmail(e.target.value);
                  }}
                  onBlur={validEmail}
                />
                <ValidationText message={errors.emailError} />
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>
                <AnyButton />
              </TableCell>
              <TableCell>
                <TextField
                  label="営業時間"
                  defaultValue={editInput.businessHours}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setBusinessHours(e.target.value);
                  }}
                />
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>
                <AnyButton />
              </TableCell>
              <TableCell>
                <TextField
                  label="休日情報"
                  defaultValue={editInput.holiday}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setHoliday(e.target.value);
                  }}
                />
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>
                <AnyButton />
              </TableCell>
              <TableCell>
                <TextField
                  label="アクセス"
                  defaultValue={editInput.access}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setAccess(e.target.value);
                  }}
                />
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>
                <AnyButton />
              </TableCell>
              <TableCell>
                <TextField
                  label="Webページ"
                  defaultValue={editInput.webPage}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setWebPage(e.target.value);
                  }}
                />
              </TableCell>
              <TableCell />
            </TableRow>
          </Table>
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openEditConfirm}>
          <PreShopEditConfirm
            backAction={backAction}
            editAction={editAction}
            editConfirm={editConfirm}
            openEditProgress={openEditProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
